var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.larosateOptions,"label":"Lärosäte","dense":"","outlined":"","clearable":"","hide-details":""},model:{value:(_vm.larosate),callback:function ($$v) {_vm.larosate=$$v},expression:"larosate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }